import type { AppState, AppAction } from '../appReducerTypes';

export function healthReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'SET_HEALTH_ANALYSIS':
      return {
        ...state,
        healthAnalysis: action.payload.analysis,
        healthAnalysisGeneratedAt: action.payload.generatedAt ?? null,
        healthAnalysisModel: action.payload.model ?? null,
        healthAnalysisError: null,
      };
    case 'RESET_HEALTH_ANALYSIS':
      return {
        ...state,
        healthAnalysis: null,
        healthAnalysisGeneratedAt: null,
        healthAnalysisModel: null,
        healthAnalysisError: null,
        isHealthAnalysisLoading: false,
      };
    case 'SET_HEALTH_ANALYSIS_ERROR':
      return { ...state, healthAnalysisError: action.payload };
    case 'SET_HEALTH_ANALYSIS_LOADING':
      return { ...state, isHealthAnalysisLoading: action.payload };
    default:
      return state;
  }
}
